import React from 'react';

import css from './ListingPage.css';

const SectionTitle = props => {
  const {
    className,
    richTitle,
  } = props;

  return (
    <div className={className}>
      <h1 className={css.title}>{richTitle}</h1>
    </div>
  );
};

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/containers/ListingPage/SectionTitle.js